<script setup lang="ts">
import DeskButton from '@/components/shared/DeskButton/DeskButton.vue';

interface DeskFormProps {
  formName: string;
  submitText: string;
  isSubmitting?: boolean;
  errors: string[];
  isValid: boolean;
  isReadonly?: boolean;
}

withDefaults(defineProps<DeskFormProps>(), {
  formName: 'Form',
  submitText: 'Submit',
  isSubmitting: false,
  isReadonly: false,
  errors: () => [],
});
</script>

<template>
  <form data-test-id="desk-form">
    <slot></slot>
    <ul
      :aria-label="`Errors for ${formName}`"
      class="form-errors text-red-600"
      v-if="errors.length"
    >
      <li v-for="(error, index) in errors" v-bind:key="'error-' + index">
        {{ error }}
      </li>
    </ul>
    <slot name="form-actions"></slot>
    <div v-if="!$slots['form-actions']" class="text-right">
      <DeskButton
        v-if="!isReadonly"
        type="submit"
        :disabled="!isValid || isSubmitting"
        :loading="isSubmitting"
        >{{ submitText }}</DeskButton
      >
    </div>
  </form>
</template>
